const i18n: { [key: string]: { [key: string]: string } } = {
  search: {
    de: 'Suche',
    fr: 'Recherche',
    it: 'Ricerca',
    en: 'Search',
  },
  searchPlaceholder: {
    de: 'Suche nach Firma oder ID',
    fr: 'Recherche par entreprise ou ID',
    it: 'Ricerca per azienda o ID',
    en: 'Search by company or ID',
  },
  switzerland: {
    de: 'Schweiz',
    fr: 'Suisse',
    it: 'Svizzera',
    en: 'Switzerland',
  },
  company: {
    de: 'Firma',
    fr: 'Entreprise',
    it: 'Azienda',
    en: 'Company',
  },
  companyName: {
    de: 'Firmenname',
    fr: 'Raison sociale',
    it: 'Ragione sociale',
    en: 'Company name',
  },
  uid: {
    de: 'UID',
    fr: 'IDE',
    it: 'IDI',
    en: 'UID',
  },
  uidTooltip: {
    de: 'Ist Ihr Unternehmen in der Schweiz ansässig, geben Sie hier ihre Unternehmens-Identifikationsnummer (UID) an.</br></br>Für ausländische Unternehmen tragen Sie bitte die Umsatzsteueridentifikationsnummer (VAT-Number) ein.',
    fr: 'Si votre entreprise a son siège en Suisse, saisissez ici votre numéro d’identification d’entreprise (IDE).</br></br>Pour les entreprises étrangères, veuillez saisir le numéro d’identification fiscale (numéro de TVA).',
    it: 'Se l’azienda ha sede in Svizzera, inserire qui il numero d’identificazione delle imprese (IDI).</br></br>Se l’azienda ha sede all’estero, indicare il numero di identificazione IVA.',
    en: 'If your company is based in Switzerland, please enter your company identification number (UID) here.</br></br>For foreign companies, please enter the value added tax identification number (VAT number).',
  },
  currentID: {
    de: 'Aktuelle ID',
    fr: 'Identifiant actuel',
    it: 'ID attuale',
    en: 'Current ID',
  },
  contact: {
    de: 'Kontakt',
    fr: 'Contact',
    it: 'Contatto',
    en: 'Contact',
  },
  firstName: {
    de: 'Vorname',
    fr: 'Prénom',
    it: 'Nome',
    en: 'First Name',
  },
  lastName: {
    de: 'Name',
    fr: 'Nom',
    it: 'Cognome',
    en: 'Last Name',
  },
  function: {
    de: 'Funktion',
    fr: 'Fonction',
    it: 'Funzione',
    en: 'Function',
  },
  phoneNumber: {
    de: 'Telefonnummer',
    fr: 'Numéro de téléphone',
    it: 'Numero di telefono',
    en: 'Phone number',
  },
  email: {
    de: 'E-Mail',
    fr: 'E-mail',
    it: 'E-mail',
    en: 'E-mail',
  },
  changeRequest: {
    de: 'Änderungswunsch',
    fr: 'Modification souhaitée',
    it: 'Richiesta di modifica',
    en: 'Change Request',
  },
  termsAcceptance: {
    de: 'Ich habe die <a href="{FILE_LINK}" download="Allgemeinen Bedingungen">Allgemeinen Bedingungen{DOWNLOAD_ICON}</a> und <a href="{LINK}" target="_blank">Datenschutzerklärung{EXTERNAL_ICON}</a> gelesen und akzeptiere sie. Ich erkläre mich ausdrücklich einverstanden mit der Veröffentlichung folgender Daten im ID Register: Firmenname, zugewiesene ID und Anbieterrolle.',
    fr: 'J’ai lu les <a href="{FILE_LINK}" download="Conditions générales">conditions générales{DOWNLOAD_ICON}</a> et la <a href="{LINK}" target="_blank">déclaration de confidentialité{EXTERNAL_ICON}</a> et les accepte. J’accepte expressément la publication des données suivantes dans le registre des identifiants: raison sociale, identifiant attribué et rôle de prestataire.',
    it: 'Ho letto e accetto le <a href="{FILE_LINK}" download="Condizioni generali">condizioni generali{DOWNLOAD_ICON}</a> e la <a href="{LINK}" target="_blank">dichiarazione sulla protezione dei dati{EXTERNAL_ICON}</a>. Acconsento espressamente alla pubblicazione dei seguenti dati nel registro ID: ragione sociale, ID assegnato, ruolo dell’operatore.',
    en: 'I have read and accept the <a href="{FILE_LINK}" download="Terms of use">terms of use{DOWNLOAD_ICON}</a> and <a href="{LINK}" target="_blank">privacy policy{EXTERNAL_ICON}</a>.',
  },
  submitButton: {
    de: 'Absenden',
    fr: 'Envoyer',
    it: 'Invia',
    en: 'Send',
  },
  requiredField: {
    de: 'Bitte prüfen/ergänzen Sie die Angaben.',
    fr: 'Veuillez vérifier/compléter les données.',
    it: 'La preghiamo di verificare/completare le informazioni.',
    en: 'Please check/complete the information.',
  },
  invalidEmail: {
    de: 'Ungültige E-Mail Adresse.',
    fr: 'Adresse électronique invalide.',
    it: 'Indirizzo e-mail non valido.',
    en: 'Invalid email address.',
  },
  invalidPhone: {
    de: 'Ungültige Telefonnummer.',
    fr: 'Numéro de téléphone non valide.',
    it: 'Numero di telefono non valido.',
    en: 'Invalid phone number.',
  },
  acceptTermsError: {
    de: 'Bitte akzeptieren Sie die Allgemeinen Bedingungen und Datenschutzerklärung.',
    fr: 'Veuillez accepter les conditions générales et la déclaration de confidentialité.',
    it: 'La preghiamo di accettare le condizioni generali e la dichiarazione sulla protezione dei dati.',
    en: 'Please accept the terms of use and privacy policy.',
  },
  street: {
    de: 'Strasse / Nr.',
    fr: 'Rue / n°',
    it: 'Via / n',
    en: 'Street / No.',
  },
  postcode: {
    de: 'PLZ',
    fr: 'NPA',
    it: 'NPA',
    en: 'ZIP',
  },
  invalidPostcode: {
    de: 'Ungültige Postleitzahl.',
    fr: 'Code postal non valide.',
    it: 'Codice postale non valido.',
    en: 'Invalid postcode.',
  },
  location: {
    de: 'Ort',
    fr: 'Lieu',
    it: 'Luogo',
    en: 'Location',
  },
  website: {
    de: 'Webseite',
    fr: 'Site web',
    it: 'Sito web',
    en: 'Website',
  },
  invalidUrl: {
    de: 'Ungültige URL',
    fr: 'URL invalide',
    it: 'URL non valido',
    en: 'Invalid URL',
  },
  country: {
    de: 'Land',
    fr: 'Pays',
    it: 'Paese',
    en: 'Country',
  },
  providerType: {
    de: 'Anbieterrolle',
    fr: 'Rôle du prestataire',
    it: 'Ruolo dell’operatore',
    en: 'Provider role',
  },
  desiredID: {
    de: 'Wunsch-ID',
    fr: 'Identifiant souhaité',
    it: 'ID personalizzato',
    en: 'Desired ID',
  },
  invalidDesiredID: {
    de: 'Maximal 3 Zeichen (Buchstaben oder Zahlen)',
    fr: 'Maximum 3 caractères (lettres ou chiffres)',
    it: 'Massimo 3 caratteri (lettere o cifre)',
    en: 'Maximum 3 characters (letters or numbers)',
  },
  desiredIDTooltip: {
    de: 'Die ID besteht aus 5 Zeichen: CH-XXX. Der Ländercode CH ist vorgegeben, für die folgenden 3 Zeichen können Sie eine Wunsch-Kombination aus Buchstaben und Zahlen angeben (z. B. ABC, R1G, 123). Wenn Sie das Feld frei lassen, wird Ihnen eine zufällige ID zugewiesen.</br></br>Im <a href="{LINK}" target="_blank">ID-Register</a>, können Sie prüfen, welche IDs bereits vergeben sind. Das Bundesamt für Energie (BFE) behält sich vor, Ihnen eine andere ID zuzuweisen, sofern Ihre Wunsch-ID bereits vergeben ist oder aus anderen Gründen nicht vergeben werden kann.',
    fr: 'L’identifiant comporte cinq caractères : CH-XXX. Le code pays CH s’inscrit par défaut. Pour les trois caractères qui suivent, vous pouvez indiquer une combinaison de lettres et de chiffres de votre choix (p. ex. ABC, R1G, 123). Si vous laissez le champ vierge, un identifiant vous sera attribué aléatoirement.</br></br>Vous pouvez voir dans <a href="{LINK}" target="_blank">le registre des identifiants</a> lles identifiants qui ont déjà été attribués. L’Office fédéral de l’énergie (OFEN) se réserve le droit de vous attribuer un autre identifiant s’il apparaît que l’identifiant que vous souhaitez est déjà attribué ou ne peut pas être utilisé pour d’autres motifs.',
    it: 'L’ID è composto da cinque caratteri: CH-XXX. Il codice del Paese CH è predefinito. Per i tre caratteri seguenti è possibile indicare una combinazione personalizzata di lettere e cifre (ad es. ABC, R1G, 123). Se si lascia il campo vuoto, verrà assegnato un ID casuale.</br></br>Nel <a href="{LINK}" target="_blank">registro degli ID</a> è possibile verificare gli ID già assegnati. L’Ufficio federale dell’energia (UFE) si riserva il diritto di assegnare un altro ID, qualora l’ID richiesto sia già stato assegnato o non possa essere assegnato per altri motivi.',
    en: 'The ID consists of 5 characters: CH-XXX. The country code CH is predefined, for the following 3 characters you can enter a desired combination of letters and numbers (e.g. ABC, R1G, 123). If you leave the field blank, you will be assigned a random ID.</br></br>In the <a href="{LINK}" target="_blank">ID register></a>, you can check which IDs have already been assigned. The Swiss Federal Office of Energy (SFOE) reserves the right to assign you a different ID if your desired ID has already been assigned or cannot be assigned for other reasons.',
  },
  removeLine: {
    de: 'Entfernen',
    fr: 'Supprimer',
    it: 'Rimuovere',
    en: 'Remove',
  },
  addLine: {
    de: 'Hinzufügen',
    fr: 'Ajouter',
    it: 'Aggiungi',
    en: 'Add',
  },
  successMessage: {
    de: 'Vielen Dank für Ihre Anfrage.</br>Sie erhalten in Kürze eine Mail. Bitte antworten Sie auf diese, um Ihre Daten zu verifizieren.',
    fr: 'Merci pour votre demande.</br>Vous allez recevoir un e-mail sous peu. Merci d’y répondre afin de vérifier vos données.',
    it: 'Grazie mille della sua richiesta.</br>A breve riceverà un’e-mail alla quale le chiediamo gentilmente di rispondere per consentirci di verificare i suoi dati.',
    en: 'Thank you for your request.</br>You will receive an e-mail shortly. Please confirm it to verify your data.',
  },
  backToForm: {
    de: 'Zurück zum Formular',
    fr: 'Retour au formulaire',
    it: 'Torna al modulo',
    en: 'Back to form',
  },
};

export default i18n;
